import { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import { Chip, Container, Grid, Stack, Typography } from '@mui/material';
// components
// mock
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import ProductCard from 'src/components/card/ProductCard';
import FillterCabinet from 'src/components/fillter/Fillter';
import ProductFilterSidebar from 'src/components/fillter/ProductFilterSidebar';
import Loader from 'src/components/loader/loader';
import ChooseCabinetModal from 'src/components/modal/ChooseCabinetModal';
import { UserListToolbar } from 'src/sections/@dashboard/user';
import { eventList, glb_sv, sendRequest, serviceList } from 'src/utils';
import crypt from 'src/utils/service/crypt';

// ----------------------------------------------------------------------

export default function GetDeviceLocal() {
    const [getFlags, setGetFlags] = useState(false);
    const getCabinetFlags = useRef();
    const [tableData, setTableData] = useState([]);
    const getDeviceFlags = useRef();
    const [dataCabinet, setDataCabinet] = useState([]);
    const [dataDrawer, setDataDrawer] = useState([]);
    const [valueCabinet, setValueCabinet] = useState(null);
    const [openFilter, setOpenFilter] = useState(false);
    const [valueDrawer, setValueDrawer] = useState(null);

    const [arrProperties, setArrProperties] = useState([]);
    const arrFillters = useRef([]);

    const params = useParams();
    const path = window.location.pathname;
    const { t } = useTranslation();
    const cabinetRef = useRef();
    const user = useRef({});
    user.current = glb_sv.userInfo;
    const [visibleCabinet, setVisibleCabinet] = useState(false);

    // console.log('User', user.current);

    useEffect(() => {
        const userData = sessionStorage.getItem('proc_data');
        if (userData) {
            try {
                const data = JSON.parse(crypt.deCode(userData));
                user.current = data;
            } catch (error) {}
        }
        console.log('user.current', user.current);

        const chooseCabinetLocal = glb_sv.getLocalStorageCabinet('cabinet');
        const chooseCabinetSession = sessionStorage.getItem('cabinet');
        try {
            if (chooseCabinetLocal || JSON.parse(chooseCabinetSession)) {
                if (chooseCabinetLocal) {
                    cabinetRef.current = chooseCabinetLocal;
                    console.log('cabinetLocal', chooseCabinetLocal);
                    getDataDrawer(chooseCabinetLocal.id);
                } else {
                    const ssCabinet = JSON.parse(chooseCabinetSession);
                    cabinetRef.current = ssCabinet;
                    // console.log('cabinetSession', ssCabinet)
                    getDataDrawer(ssCabinet.id);
                }
            } else {
                setVisibleCabinet(true);
            }
        } catch (error) {}
    }, []);

    useEffect(() => {
        if (cabinetRef.current?.id && cabinetRef.current?.id !== 0) {
            getData(cabinetRef.current.id, valueDrawer?.id ? valueDrawer.id : null);
        }
    }, [cabinetRef.current?.id, valueDrawer?.id, arrProperties]);

    const getData = useCallback(
        (idCabin, idDraw) => {
            const arrFillters = arrProperties.map((item) => {
                const checkedValues = item.value
                    .filter((subItem) => subItem.checked === true)
                    .map((subItem) => subItem.value);
                return { label: item.label, value: checkedValues };
            });
            if (getDeviceFlags.current) {
                return;
            }
            getDeviceFlags.current = true;
            setGetFlags(true);
            if (user.current.group_user !== '3') {
                if (!cabinetRef.current?.id && !valueDrawer?.id) {
                    const InVal = [
                        user.current.depart_cd,
                        arrFillters.filter((item) => item.value.length > 0),
                        +params.idGroup,
                    ];
                    setTimeout(() => {
                        sendRequest(serviceList.getAllDeviceTake, InVal, getDataResult, true, timeOutFunct, 40000);
                    }, 1000);
                }
                if (!valueDrawer?.id && cabinetRef.current?.id) {
                    const InVal = [
                        cabinetRef.current.id,
                        user.current.depart_cd,
                        arrFillters.filter((item) => item.value.length > 0),
                        +params.idGroup,
                    ];
                    setTimeout(() => {
                        sendRequest(
                            serviceList.getAllDeviceTakeCabinet,
                            InVal,
                            getDataResult,
                            true,
                            timeOutFunct,
                            40000
                        );
                    }, 1000);
                }
                if (valueDrawer?.id && cabinetRef.current?.id) {
                    const InVal = [
                        cabinetRef.current.id,
                        valueDrawer.id,
                        user.current.depart_cd,
                        arrFillters.filter((item) => item.value.length > 0),
                        +params.idGroup,
                    ];
                    setTimeout(() => {
                        sendRequest(
                            serviceList.getAllDeviceTakeDrawer,
                            InVal,
                            getDataResult,
                            true,
                            timeOutFunct,
                            40000
                        );
                    }, 1000);
                }
            } else {
                if (!valueDrawer?.id) {
                    const InVal = [
                        // cabinetRef.current.id,
                        idCabin,
                        user.current.depart_cd,
                        arrFillters.filter((item) => item.value.length > 0),
                        +params.idGroup,
                    ];
                    setTimeout(() => {
                        sendRequest(
                            serviceList.getAllDeviceTakeCabinet,
                            InVal,
                            getDataResult,
                            true,
                            timeOutFunct,
                            40000
                        );
                    }, 1000);
                }
                if (valueDrawer?.id) {
                    const InVal = [
                        idCabin,
                        idDraw,
                        user.current.depart_cd,
                        arrFillters.filter((item) => item.value.length > 0),
                        +params.idGroup,
                    ];
                    setTimeout(() => {
                        sendRequest(
                            serviceList.getAllDeviceTakeDrawer,
                            InVal,
                            getDataResult,
                            true,
                            timeOutFunct,
                            40000
                        );
                    }, 1000);
                }
            }
        },
        [cabinetRef.current?.id, valueDrawer?.id, arrProperties]
    );

    const getDataResult = (reqInfoMap, message) => {
        setGetFlags(false);
        getDeviceFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setTableData(message.proc_data.rows[0].o_1);
            arrFillters.current = message.proc_data.rows[0].o_1;
        }
    };

    const getDataDrawer = useCallback((id) => {
        const InVal = [id];
        sendRequest(serviceList.getAlldrawerSp, InVal, getDataDrawerResult, true, timeOutFunct, 40000);
    }, []);

    const getDataDrawerResult = (reqInfoMap, message) => {
        setGetFlags(false);
        getDeviceFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDataDrawer([{ drawer_nm: t('all'), id: 0 }, ...message.proc_data.rows[0].o_1]);
        }
    };

    const timeOutFunct = (reqInfo) => {
        setGetFlags(false);
        getDeviceFlags.current = false;
        // toast.error(t('error.time_out'));
    };

    const generateUniqueId = () => {
        const uniqueId = Math.random().toString(36).substr(2, 9);
        return uniqueId;
    };

    const handleAddCatagory = (data, qty, note) => {
        // const arr = [];
        // arr.push({ ...data, qty: qty, inventory: data.qty, note: note });
        // sessionStorage.setItem('category', JSON.stringify(arr));
        const getSessions = sessionStorage.getItem('category');
        if (getSessions) {
            try {
                const arrCategories = JSON.parse(getSessions);
                arrCategories.push({
                    ...data,
                    qty: qty,
                    inventory: data.qty,
                    note: note,
                    idCategory: generateUniqueId(),
                    create_time: new Date().getTime()
                });
                sessionStorage.setItem('category', JSON.stringify(arrCategories));
            } catch (error) {}
        } else {
            const arr = [];
            arr.push({
                ...data,
                qty: qty,
                inventory: data.qty,
                note: note,
                idCategory: generateUniqueId(),
                create_time: new Date().getTime(),
            });
            sessionStorage.setItem('category', JSON.stringify(arr));
        }
        glb_sv.commonEvent.next({ type: eventList.ADD_PRODUCT, data: 'add' });
        toast.success(t('action_success_'), { position: 'top-left' });
    };

    const fillterSearcher = (value) => {
        if (value === '' || !value) {
            return setTableData(arrFillters.current);
        }
        const arrSearch = arrFillters.current.filter(
            (data) => data.device_nm.includes(value.toUpperCase()) || data.device_cd.includes(value.toUpperCase())
        );
        setTableData(arrSearch);
    };

    const handleDelete = (item, index, indexParent) => {
        // arrProperties.splice(index, 1);
        // setArrProperties([...arrProperties]);
        if (item) {
            arrProperties[indexParent].value[index] = {
                ...arrProperties[indexParent].value[index],
                checked: !arrProperties[indexParent].value[index].checked,
            };
            setArrProperties([...arrProperties]);
        }
    };

    return (
        <>
            <Helmet>
                <title> {t('getting_device')} </title>
            </Helmet>

            <Container>
                <Loader loading={getFlags} />
                <Typography variant="h4" sx={{ mb: 1 }}>
                    {t('getting_device')}
                </Typography>
                <Breadcrumb
                    paths={[
                        {
                            label: t('group_devices'),
                            url: `/home/group/${path?.split('/')[3]}/${params.idPermission}`,
                            navigate: false,
                        },
                        { label: t('getting_device'), url: '#', navigate: false },
                    ]}
                />
                <ChooseCabinetModal visible={visibleCabinet} setVisible={setVisibleCabinet} />
                <Grid container spacing={2} alignItems={'center'} sx={{ mb: 1 }}>
                    <Grid item xs={12} sm={12} md={6} xl={8}>
                        <UserListToolbar getValue={fillterSearcher} />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} xl={4}>
                        <Stack
                            direction="row"
                            alignItems="center"
                            width={'100%'}
                            justifyContent="flex-end"
                            flexWrap={'wrap'}
                            gap={1}
                        >
                            {cabinetRef.current ? (
                                <>
                                    <Typography variant="subtitle2" sx={{ color: 'inherit' }}>
                                        {t('cabinet')}:{' '}
                                    </Typography>
                                    <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                                        {`${cabinetRef.current.cabinet_nm} - ${cabinetRef.current.cabinet_cd}`}
                                    </Typography>
                                </>
                            ) : (
                                <>
                                    <Typography variant="subtitle2" sx={{ color: 'inherit' }}>
                                        {t('cabinet')}:{' '}
                                    </Typography>
                                    <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                                        {t('no_cabinet')}
                                    </Typography>
                                </>
                            )}
                            {/* {glb_sv.userInfo.group_user !== '3' && (
                                <FillterCabinet
                                    setValueSort={(data) => {
                                        setValueCabinet(data);
                                        setValueDrawer({ drawer_nm: t('all'), id: null });
                                    }}
                                    arrSort={dataCabinet}
                                    labelDisplay="cabinet_nm"
                                    defaultValue={dataCabinet.length > 0 ? dataCabinet[0].cabinet_nm : ''}
                                    title={t('cabinet')}
                                />
                            )} */}
                            <FillterCabinet
                                setValueSort={setValueDrawer}
                                labelDisplay="drawer_nm"
                                arrSort={dataDrawer}
                                valueSort={valueDrawer ? valueDrawer : null}
                                defaultValue={dataDrawer.length > 0 ? dataDrawer[0].drawer_nm : ''}
                                title={t('drawer')}
                            />
                            <ProductFilterSidebar
                                valueChange={arrProperties}
                                openFilter={openFilter}
                                getValue={setArrProperties}
                                onCloseFilter={() => setOpenFilter(false)}
                                onOpenFilter={() => setOpenFilter(true)}
                            />
                        </Stack>
                    </Grid>
                    <Stack direction="row" flexWrap={'wrap'} padding={2} spacing={1}>
                        {arrProperties.length > 0 &&
                            arrProperties.map((item, index) => {
                                return (
                                    <div key={index} style={{ gap: 1 }}>
                                        {item?.value?.length > 0 &&
                                            item.value.map((value, idx) => {
                                                if (value.checked) {
                                                    return (
                                                        <Chip
                                                            variant="outlined"
                                                            key={idx}
                                                            sx={{ marginLeft: 1 }}
                                                            label={glb_sv.convertMultipleLanguages(value?.label)}
                                                            color="primary"
                                                            // onClick={() => handleClick(item, index)}
                                                            onDelete={() => handleDelete(item, idx, index)}
                                                        />
                                                    );
                                                }
                                            })}
                                    </div>
                                );
                            })}
                    </Stack>
                    {/* <Stack direction="row" flexWrap={'wrap'} paddingBottom={2} paddingLeft={3}>
                        {arrProperties.length > 0 &&
                            arrProperties.map(
                                (item, index) =>
                                    item.checked && (
                                        <Chip
                                            variant="outlined"
                                            key={index}
                                            label={item?.properties_nm}
                                            // onClick={() => handleClick(item, index)}
                                            onDelete={() => handleDelete(item, index)}
                                        />
                                    )
                            )}
                    </Stack> */}
                </Grid>
                <Grid container spacing={3}>
                    {tableData.map((product, index) => {
                        if (product.status_action === '1') {
                            return (
                                <Grid key={index} item xs={6} sm={4} md={3} xl={2.4}>
                                    <ProductCard cal product={product} functOnClick={handleAddCatagory} />
                                </Grid>
                            );
                        }
                    })}
                </Grid>
            </Container>
        </>
    );
}
